/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
type Format = 'image/png' | 'image/jpeg' | 'image/gif' | 'application/pdf';

export const convertToBase64 = (canvas: HTMLCanvasElement, format: Format = 'image/png') => {
  return canvas.toDataURL(format);
};
